import React from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import axios from "axios";
import { ProgressSpinner } from "primereact/progressspinner";
import { toast } from "../../components/Toast/toast.ts";

const BorderLinearProgress = styled(LinearProgress)(({ value }: { value: number }) => ({
  height: 8,
  borderRadius: "50px",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "rgb(var(--surface-3))",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: "50px",
    background: value > 20
      ? "linear-gradient(256deg, #649c35 0, #0aca91 100%)"
      : "linear-gradient(270deg, rgba(255, 57, 30, 0.82) 0.01%, #FFA1A1 99.98%)",
  },
}));

export default function IotBattery() {
  const storedToken = localStorage.getItem("token");
  const [Data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const fetchCount = async () => {
      if (storedToken) {
        try {
          setLoading(true);
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/cust-portal/battery-life`, {
            headers: { Authorization: `Bearer ${storedToken}` },
          });
          setData(response?.data);
          setLoading(false);
        } catch (error: any) {
          toast.error(error?.response?.data?.message || error?.message || "Unable to retrieve battery-life!");
          setLoading(false);
        }
      }
    };
    fetchCount();
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[120px]">
        <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="3" animationDuration=".5s" />
      </div>
    );
  }

  if (!Data || Data.length === 0) {
    return <p className="text-[13px] text-[rgb(var(--text-muted))] text-center py-6">No battery data available.</p>;
  }

  return (
    <div className="flex flex-col gap-3">
      {Data.map((item: any) => (
        <div key={item._id} className="flex items-center gap-3">
          <span className="text-[13px] text-[rgb(var(--text-secondary))] min-w-[120px] truncate">
            {item?.store_id?.name}
          </span>
          <div className="flex-1">
            <Stack spacing={2} sx={{ flexGrow: 1 }}>
              <BorderLinearProgress variant="determinate" value={item.remaining_life} sx={{ height: "8px" }} />
            </Stack>
          </div>
          <span className={`text-[12px] font-semibold min-w-[36px] text-right ${item.remaining_life > 20 ? "text-[rgb(var(--success))]" : "text-[rgb(var(--danger))]"}`}>
            {Math.floor(item?.remaining_life)}%
          </span>
        </div>
      ))}
    </div>
  );
}
